import Image from "./Image";
import ImageServiceInterface from "./ImageServiceInterface";

export default class ImageService implements ImageServiceInterface {
    images: Array<Image>;

    constructor() {
        this.images = [];
    }

    /**
     * @param image
     */
    add(image: Image) {
        this.images.push(image);

        return this;
    }

    getAll(): Array<Image> {
        return this.images
    }
}





// WEBPACK FOOTER //
// ./src/Models/imageModels/ImageService.ts